import axios from 'axios'
// import {
//   Message,
//   MessageBox
// } from 'element-ui'
// import store from '@/store/index'
// import {
//   getToken
// } from '@/utils/auth'
import router from '@/router/index'

axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
//axios.defaults.baseURL = proce.env.NODE_ENV === 'production' ? 'http://www.ky200.com' : '/api'
/*
 * 增加request请求拦截器
 */
axios.interceptors.request.use((config) => {
  // 预处理请求的信息
  if (config.url != '/api/uaa/oauth/token') {
    if (localStorage.userToken) {
      // 设置统一请求头
      config.headers.Authorization = localStorage.userToken;
    }
  }

  return config
}, (error) => {
  // 预处理请求有异常error时抛出错误
  return Promise.reject(error)
})
/*
 * 增加respone响应拦截器
 */
axios.interceptors.response.use((response) => {
  // 预处理相应的数据
  return response
}, (error) => {
  // 错误返回 状态码验证
  if (error.response.status == 401) {

    router.push('/login');
    // 清除失效token
    sessionStorage.removeItem('userToken');
  }

  checkStatus(error)
  return Promise.reject(error)

})

function checkStatus(error) {
  // 有响应时校验状态
  if (error) {
    // -10 自己定义，连接错误的status
    const status = error.response.status || -10

    if (status === 200 || status === 304) {
      return response.data
    } else {
      let errorInfo = ''
      switch (status) {
        case -1:
          errorInfo = '远程服务响应失败,请稍后重试'
          break
        case 400:
          errorInfo = '400: 错误请求'
          break
        case 401:
          errorInfo = '401: 访问令牌无效或已过期, 请重新登录！'
          // 直接跳到登录页面
          break
        case 403:
          errorInfo = '403: 拒绝访问'
          break
        case 404:
          errorInfo = '404：资源不存在'
          break
        case 405:
          errorInfo = '405: 请求方法未允许'
          break
        case 408:
          errorInfo = '408: 请求超时'
          break
        case 500:
          errorInfo = '500：访问服务失败'
          break
        case 501:
          errorInfo = '501：未实现'
          break
        case 502:
          errorInfo = '502：无效网关'
          break
        case 503:
          errorInfo = '503: 服务不可用'
          break
        // 其他错误
        default:
          errorInfo = `连接错误${status}`
      }
      return {
        status,
        msg: errorInfo
      }
    }
  }
  // 异常状态下，返回错误信息
  return {
    status: -404,
    msg: '网络异常'
  }
}




// 创建axios实例
//const service = axios.create({
//  baseURL: process.env.BASE_API, // api的base_url
//  timeout: 5000, // 请求超时时间
//})

// request拦截器
//service.interceptors.request.use(
//  config => {
//    if (store.getters.token) {
//      config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
//    }
//
//
//
//    return config
//  },
//  error => {
//    // Do something with request error
//    console.log(error) // for debug
//    Promise.reject(error)
//
//  }
//)

// respone拦截器
//service.interceptors.response.use(
//  response => {
//    /**
//     * code为非20000是抛错 可结合自己业务进行修改
//     */
//    const res = response.data
//    if (res.code !== 20000) {
//      Message({
//        message: res.message,
//        type: 'error',
//        duration: 5 * 1000
//      })
//
//      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
//      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
//        MessageBox.confirm(
//          '你已被登出，可以取消继续留在该页面，或者重新登录',
//          '确定登出',
//          {
//            confirmButtonText: '重新登录',
//            cancelButtonText: '取消',
//            type: 'warning'
//          }
//        ).then(() => {
//          store.dispatch('FedLogOut').then(() => {
//            location.reload() // 为了重新实例化vue-router对象 避免bug
//          })
//        })
//      }
//      return Promise.reject('error')
//    } else {
//      return response.data
//    }
//  },
//  error => {
//    console.log('err' + error) // for debug
//    Message({
//      message: error.message,
//      type: 'error',
//      duration: 5 * 1000
//    })
//    return Promise.reject(error)
//  }
//)
//
//export default service
//



// WEBPACK FOOTER //
// ./src/utils/request.js